import { type ReactNode } from "react";
import { PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import { AppSettingsProvider } from "@/contexts/AppSettingsContext";
import { PageTitleProvider } from "@/contexts/PageTitleContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { UserbackProvider } from "@/contexts/UserbackContext";
import { useSentryUserContext } from "@/hooks/useSentryUserContext";

interface ProvidersProps {
  children: ReactNode;
}

/**
 * Headless component that re-applies the Sentry user-context payload whenever
 * the authenticated user or active organization changes. Must live below
 * `AuthProvider` so it can read `AuthContext`.
 */
const SentryUserContextSync = () => {
  useSentryUserContext();
  return null;
};

export const Providers = ({ children }: ProvidersProps) => {
  return (
    <PostHogProvider client={posthog}>
      <AppSettingsProvider>
        <PageTitleProvider>
          <AuthProvider>
            <SentryUserContextSync />
            <UserbackProvider>{children}</UserbackProvider>
          </AuthProvider>
        </PageTitleProvider>
      </AppSettingsProvider>
    </PostHogProvider>
  );
};
